import React, { useEffect, useRef, useState } from "react";
import "./Events.css";
import { Helmet } from "react-helmet";
import { BASEURL } from "../../../constant/constant";
import EventMain from "../../../Assets/image/events/EVENT COVER PAGE BLUR.webp";

const EventsPage = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [featuredEvent, setFeaturedEvent] = useState(null);
  const hasFetched = useRef(false);
  // Modal state
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState(null);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${BASEURL}/api/event/getEvents`, {
        method: "GET",
        redirect: "follow",
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success && result.data && result.data.length > 0) {
        setEvents(result.data);
        // setFeaturedEvent(result.data[0]);
      } else {
        setEvents([]);
        setFeaturedEvent(null);
      }
    } catch (err) {
      console.error("Error fetching events:", err);
      setError("Failed to load events. Please try again later.");
      setEvents([]);
      setFeaturedEvent(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
    fetchEvents();
    hasFetched.current = true;
  }, []);
  const fetchEventDetail = async (eventId) => {
    try {
      setModalLoading(true);
      setModalError(null);
      const response = await fetch(`${BASEURL}/api/event/getEvents/${eventId}`, {
        method: "GET",
        redirect: "follow"
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      if (result.success && result.data) {
        setSelectedEvent(result.data);
      }
    } catch (err) {
      console.error("Error fetching event detail:", err);
      setModalError("Failed to load event details.");
    } finally {
      setModalLoading(false);
    }
  };

  const openModal = (eventId) => {
    fetchEventDetail(eventId);
  };

  const closeModal = () => {
    setSelectedEvent(null);
    setModalLoading(false);
    setModalError(null);
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatTime = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <>
      <Helmet>
        <title>Solar Technology Events & Exhibitions | SEA Automation</title>
        <meta name="description" content="Join Sandip electronics & Automation (SEA) at India's leading solar and agriculture exhibitions. Stay updated on our latest product launches, live demos, and technical workshops." />
        <meta name="keywords" content="Solar exhibitions India, Krishi exhibition  Pune(India), solar pump controller demo, SEA product launch, technical workshop for solar installers, agriculture trade fairs" />
        <meta property="og:title" content="Latest Events & Solar Tech Demos by SEA" />
        <meta property="og:description" content="Catch us live at the next major agriculture and solar trade fair. See our IoT controllers in action!" />
        <meta property="og:image" content="https://official.seaiot.in/assets/exhibition-booth-preview.jpg" />
        <meta property="og:url" content="https://official.seaiot.in/eventsPage" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://official.seaiot.in/eventsPage" />
      </Helmet>

      <div className="events-wrapper-div">
        <div className="events-wrapper">
          {/* Featured Event */}
          <section className="featured">
            <div className="featured-img" >
              <img src={EventMain} alt="Upcoming Events" />
            </div>
          </section>

          {/* Event Grid */}
          <section className="events-grid">
            {loading ? (
              <div className="loading-state">Loading events...</div>
            ) : error ? (
              <div className="error-state">{error}</div>
            ) : events.length > 0 ? (
              events.map((event) => (
                <div className="event-card" onClick={() => openModal(event._id)} key={event._id}>
                  <div className="event-card-img">
                    <img
                      src={`${BASEURL}${event.cover_photo}`}
                      alt={event.event_name}
                    />
                  </div>
                  <div className="card-content">
                    <span className="meta">
                      <b> {formatDate(event.date.start)} To {formatDate(event.date.end)}</b>
                    </span>
                    <h3>{event.event_name}</h3>
                  </div>
                  <button
                    className="link-btn-2 card-btn"
                  >
                    View Details →
                  </button>
                </div>
              ))
            ) : (
              <div className="no-events">No upcoming events</div>
            )}
          </section>
        </div>
      </div>

      {/* Event Detail Modal */}
      {selectedEvent && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {modalLoading ? (
              <div className="modal-loading">Loading event details...</div>
            ) : modalError ? (
              <div className="modal-error">{modalError}</div>
            ) : (
              <>
                <button className="modal-close" onClick={closeModal}>×</button>
                <div className="modal-main">
                  <img
                    src={`${BASEURL}${selectedEvent.cover_photo}`}
                    alt={selectedEvent.event_name}
                    className="modal-cover"
                  />
                  <div className="modal-info">
                    <span className="meta">
                      {formatDate(selectedEvent.date.start)} TO {formatDate(selectedEvent.date.end)}
                    </span>
                    <h2>{selectedEvent.event_name}</h2>
                    <p className="modal-description">{selectedEvent.description}</p>
                  </div>
                </div>

                {selectedEvent.image_gallery && selectedEvent.image_gallery.length > 0 && (
                  <div className="modal-gallery">
                    <h3>Photo Gallery</h3>
                    <div className="gallery-grid">
                      {selectedEvent.image_gallery.map((img, index) => (
                        <img
                          key={index}
                          src={`${BASEURL}${img}`}
                          alt={`Gallery ${index + 1}`}
                          className="gallery-img"
                        />
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default EventsPage;
